import { meetingRepo } from "@/repositories/meetingRepo";
import { useObservable } from "@repo/ui/components/Base/hooks/useObservable";
import { map } from "rxjs";
import { teamFilter, type TeamIdOrOrg } from "./common";

export const useGetMeeting = (tenantId: string, meetingId: string) => {
  return useObservable(
    () => meetingRepo.get(tenantId, meetingId),
    [tenantId, meetingId]
  );
};

export const useMeetingList = (tenantId: string, teamId: TeamIdOrOrg) => {
  return useObservable(
    () => meetingRepo.list(tenantId).pipe(map(teamFilter(teamId))),
    [tenantId, teamId]
  );
};
